import FilterModule from "../../components/Campaigns/FilterModuleSold"

function LeftSideContainer() {
  return (
    <div className="flex flex-col">
      <FilterModule />
    </div>
  )
}

export default LeftSideContainer
